<template>
  <!-- WORKAROUND: Adjust width according to min-width of cockpit -->
  <footer class="app-footer" :class="{ 'app-footer-cockpit': isCockpit }">
    <div class="col-12 col-sm text-nowrap">MSM loop v{{ frontendVersion }} &copy; MSM Germany</div>
    <b-nav class="col-12 col-sm-auto ml-auto">
      <b-nav-item to="/imprint">{{ $t('Webportal.Imprint') }}</b-nav-item>
      <b-nav-item to="/dataprotection">{{ $t('Webportal.DataProtection') }}</b-nav-item>
    </b-nav>
    <div class="col-12 col-sm-auto ml-auto">Fon +49(0)-251-1 42 35-0</div>
    <div class="col-12 col-sm-auto ml-auto"><a v-bind:href="supportEmailHref">{{ supportEmail }}</a></div>
  </footer>
</template>

<script>
import AppConfig from '@/mixins/AppConfig-APP_TARGET';

export default {
  name: 'AppFooter',

  mixins: [ AppConfig ],

  computed: {
    isCockpit() {
      return this.$route.name === 'Cockpit'
    },

    frontendVersion() {
      return FRONTEND_VERSION;
    },

    supportEmailHref() {
      return 'mailto:' + this.getEmail();
    },

    supportEmail() {
      return this.getEmail();
    }
  }
}
</script>
